import styled from 'styled-components';

import { TableContainer } from 'components/DefaultTable/styles';

export const Table = styled(TableContainer)`
  .table-responsive {
    padding: 32px 40px;
  }

  tr th:last-child,
  tr td:last-child {
    text-align: center;
  }

  tr td {
    &:first-child {
      width: 25%;
    }

    &:nth-child(2) {
      width: 50%;
    }
  }
`;

export const Button = styled.button.attrs({
  type: 'button',
})`
  cursor: pointer;
  background-color: transparent;
  border: 0;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 0.4;
  }

  & + button {
    margin-left: 16px;
  }
`;
